var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-material-card',_vm._g(_vm._b({staticClass:"v-card--material-chart"},'base-material-card',_vm.$attrs,false),_vm.$listeners),[_vm._t("reveal-actions",null,{"slot":"reveal-actions"}),_vm._t("default"),_vm._t("actions",null,{"slot":"actions"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }